var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-container"},[_c('div',{staticClass:"text-continue-title"},[_vm._v(" 当前对话已结束，点击下方按钮继续对话 ")]),_c('div',{staticClass:"text-continue-btn"},[_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":_vm.continueDialogue}},[_vm._v("继续对话")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }